import React, { useState } from 'react';
import { useAuth } from './AuthContext'; // Import the AuthContext
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Logout from './Logout';
import goldcleats_ai_logo from "../assets/goldcleats_ai_logo.png"

function Header() {
    const { user, loading } = useAuth(); // Access the user and loading state from AuthContext
    const [menuOpen, setMenuOpen] = useState(false); // State to manage menu toggle

    const toggleMenu = () => {
        setMenuOpen((prev) => !prev); // Toggle menu open/close state
    };

    const handleLogin = () => {
        window.location.href = "/login"; // Redirect to login page
    };

    return (
        <header className="py-3 header-gradient sticky-header">
            <div className="container d-flex align-items-center justify-content-between">
                {/* Logo and Branding */}
                <div className="d-flex align-items-center">
                    <Link to="/" className="d-flex align-items-center mr-3">
                        <img
                            src="https://www.goldcleats.com/gc-content/themes/goldcleats/UI/img/player/appicon_goldcleats_48.png?crc=09122021"
                            alt="GoldCleats Logo"
                            width="48"
                            height="48"
                        />
                    </Link>
                    <div className="d-none d-lg-block text-left ml-2">
                        <img
                            src={goldcleats_ai_logo}
                            alt="GoldCleats Logo"
                            width="250"

                        />
                        {/* <p className="mb-0 font-weight-bold text-white header-text">
                            GOLDCLEATS
                        </p>
                        <p className="mb-0 text-white">
                            Where Future stars are born
                        </p> */}
                    </div>
                </div>

                {/* Hamburger Menu for Mobile */}
                <button
                    className="navbar-toggler d-lg-none d-md-none"
                    type="button"
                    aria-expanded={menuOpen ? "true" : "false"}
                    aria-label="Toggle navigation"
                    onClick={toggleMenu}
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                {/* Navigation Links */}
                <nav
                    id="navbarNav"
                    className={`collapse ml-auto d-flex align-items-center ${menuOpen ? "show" : ""
                        }`}
                >
                    <Link to="/features" className="nav-link text-white px-3">
                        Features
                    </Link>
                    <Link to="/about-us" className="nav-link text-white px-3">
                        About
                    </Link>
                    <Link to="/pricing" className="nav-link text-white px-3">
                        Pricing
                    </Link>
                    <Link to="/contact-us" className="nav-link text-white px-3">
                        Contact Us
                    </Link>

                    {/* Login or Logout Button */}
                    {!loading && (
                        user ? (
                            <Logout />
                        ) : (
                            <button onClick={handleLogin} className="btn btn-login ml-3">
                                Login to Explore
                            </button>
                        )
                    )}
                </nav>
            </div>
        </header>
    );
}

export default Header;
